import { render, staticRenderFns } from "./VideoSingle.vue?vue&type=template&id=106a43f0&scoped=true"
import script from "./VideoSingle.vue?vue&type=script&lang=js"
export * from "./VideoSingle.vue?vue&type=script&lang=js"
import style0 from "./VideoSingle.vue?vue&type=style&index=0&id=106a43f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106a43f0",
  null
  
)

export default component.exports